import {CartIcon} from '@/components/svg/CartIcon';
import {Box} from '@chakra-ui/layout';
import {
  Button,
  Spinner,
  StyleProps,
  useBreakpointValue,
} from '@chakra-ui/react';

export const BuyButton: React.FC<
  {
    libelle: string;
    onClick: () => void;
    isSubmitting: boolean;
    iconColor?: string;
  } & StyleProps
> = ({libelle, onClick, isSubmitting, iconColor, ...styleProps}) => {
  const breakpointIconColor = useBreakpointValue({
    base: 'white',
    md: 'blue.main',
  });
  const iconColorValue = iconColor ?? breakpointIconColor;

  return (
    <Button
      fontSize='sm'
      width={{base: '100%', md: 'initial'}}
      height='35px'
      border='1px'
      borderColor='blue.main'
      bg={{base: 'blue.main', md: 'white'}}
      _hover={{
        bg: {base: 'blue.dark', md: 'gray.light'},
        borderColor: {base: 'blue.dark', md: 'blue.main'},
      }}
      color={{base: 'white', md: 'blue.main'}}
      px='4'
      iconSpacing='0'
      flex={1}
      leftIcon={
        isSubmitting ? (
          <Spinner
            color='brand.500'
            aria-label='Chargement...'
          />
        ) : (
          <Box mr='5px'>
            <CartIcon
              color={iconColorValue ?? 'white'}
              height='22px'
              width='22px'
            />
          </Box>
        )
      }
      opacity={isSubmitting ? '0.5' : '1.0'}
      onClick={onClick}
      isDisabled={isSubmitting}
      {...styleProps}
    >
      {libelle}
    </Button>
  );
};
